/*
 * @Auther: 罗耀祖
 * @Date: 2021-08-02 09:29:41
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-03-17 15:09:35
 * @name: 发送短信验证码
 * @Description: 发送短信验证码
 * @FilePath: \project\src\mixins\sendVerification.js
 * @Author: DESKTOP-1QU67QM
 */

import commonService from "@/module/common/common.service.js";
export default {
	data() {
		return {
			commonService: new commonService(),
			countdown: 0, //验证码倒计时
			interval: "", //定时器
		}
	},
	beforeDestroy() {
		clearInterval(this.interval);
	},
	methods: {
		/**
		 * @Auther: 罗耀祖
		 * @LastEditors: 罗耀祖
		 * @description: 发送验证码
		 */
		sendVerificationCode(mobile, scene) {
			if (this.countdown > 0) {
				return;
			}
			this.commonService.sendVerificationCode({ mobile, scene }).then(res => {
				this.countdown = this.commonService.sms_countdown;
				this.interval = setInterval(() => {
					this.countdown--;
					if (this.countdown === 0) {
						clearInterval(this.interval);
					}
				}, 1000);
			})
		},
	}
}
